/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastchangeonjahrgangsstufe3Inputs */

const de__field_lastchangeonjahrgangsstufe3 = /** @type {(inputs: _Field_Lastchangeonjahrgangsstufe3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Änderung der Jahrgangsstufe am`)
};

/**

* @param {_Field_Lastchangeonjahrgangsstufe3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lastchangeonjahrgangsstufe3 = /** @type {((inputs?: _Field_Lastchangeonjahrgangsstufe3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastchangeonjahrgangsstufe3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lastchangeonjahrgangsstufe3(inputs)
});
export { _field_lastchangeonjahrgangsstufe3 as "_field_lastChangeOnJahrgangsstufe" }